import {Typography} from '@logistics-frontend/blocks'
import React from 'react'

import {usePaymentTitle} from './hooks'
import {Props} from './types'

export function PaymentTitle(props: Props) {
  const {method} = props
  const title = usePaymentTitle(method)

  return (
    <Typography group="tight" variant="body2" whiteSpace="nowrap">
      {title}
    </Typography>
  )
}
